import axios from 'axios';
import { message } from 'ant-design-vue';
import qs from 'qs';
import store from '@/store';
import router from '@/router';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'content-type': 'application/json;charset=utf-8'
  },
  withCredentials: true,
  timeout: 50000 // 请求超时时间
});

//请求
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = store.getters.token;
  }
  return config;
});

//响应
service.interceptors.response.use(response => {
  const data = response.data;
  if (data.success == 1) {
    return Promise.resolve(response);
  } else {
    message.error(response.data.msg || '网络错误');
    if (data.success == 10009) {
      store.dispatch('user/logout', true);
      router.replace({
        path: '/login'
      });
    }
    return Promise.reject(response);
  }
});
let http = {};

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

http.get = function (url, params = null) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params
    }).then(res => {
      resolve(res.data);
    }).catch(e => {
      reject(e);
    });
  });
};

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

http.post = function (url, data) {
  return new Promise((resolve, reject) => {
    service.post(url, data).then(res => {
      resolve(res.data);
    }).catch(e => {
      reject(e);
    });
  });
};
export default http;